// The speeds the student navbar offers, and what the API validates writes against.
export const CONVERSATION_PLAYBACK_SPEEDS: readonly number[] = [
  0.5, 0.75, 1.0, 1.25, 1.5, 2.0, 3.0,
];

export const DEFAULT_CONVERSATION_PLAYBACK_SPEED = 1.0;

// A speed off this list is unplayable: 0 makes the message delay infinite.
export function isConversationPlaybackSpeed(value: number | null | undefined): value is number {
  return value != null && CONVERSATION_PLAYBACK_SPEEDS.includes(value);
}
